import React from 'react'

import Mark from './common/Mark'

const Footer = () => {
  const date = new Date().getFullYear()
  return (
      <footer className="footer fixed-bottom border-top text-center">
          <Mark height={24} width={24} />
          <span className="text-muted"><a target="_blank" rel="noopener noreferrer" href="https://www.jellyfish.chat">Jellyfish</a> &copy; {date}</span>
          {/*<a className="pl-4" target="_blank" href="https://www.jellyfish.chat/support.html">Need Help?</a>*/}
          <a className="pl-4" target="_blank" href="https://help.jellyfish.chat/">Need Help?</a>

      </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx